import Radio from './Radio';

// export types
export type { RadioProps } from './Radio';

// export components
export { Radio };
export default Radio;
